import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BlogEntity } from 'src/app/interfaces/blog/blog-entity';
import { BlogMobileSearchComponent } from '../blog-search/blog-mobile-search/blog-mobile-search.component';

@Component({
  selector: 'drme-blog-main',
  templateUrl: './drme-blog-main.component.html',
  styleUrls: ['./drme-blog-main.component.css']
})
export class DrmeBlogMainComponent implements OnInit {

  constructor(public http: HttpClient,
    public bottomSheet: MatBottomSheet
  ) { }

  ngOnInit(): void {
    this.getBlogs();
  }

  public onOpenMobileSearch() {
    this.bottomSheet.open(BlogMobileSearchComponent);
  }

  public onCloseDrawer() {
    this.isOpenDrawer = false;
  }
  public onOpenDrawer() {
    this.isOpenDrawer = true;
  }

  public getBlogs() {
    let url = 'assets/blog.json'
    this.http.get(url).subscribe(r => {
      console.log(r)
      this.blogsList = r as BlogEntity[];
    })
  }

  public isOpenDrawer: boolean = false;
  public blogsList!: BlogEntity[];

}
